<template>
    <div>
        <span class="badge bg-primary" role="button" @click="$router.push(back)"><i
                class="bi bi-arrow-left-circle-fill"></i> Retour</span>
    </div>

</template>

<script>
export default {
    name: "Backlink",

    props: {
        back: {
            type: { Object, String },
            default: () => ({})
        }
    }
}

</script>